import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "informations-content",
  class: "kn-flex kn-relative kn-height-full"
}
const _hoisted_2 = { class: "roles-absolute-scroll" }
const _hoisted_3 = { class: "p-grid" }
const _hoisted_4 = { class: "p-field-checkbox p-m-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Card, { class: "kn-card no-padding" }, {
        content: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rolesManagementTabViewDescriptor.categories, (category, index) => {
            return (_openBlock(), _createBlock("div", { key: index }, [
              (_ctx.authorizationCBs[category.categoryName] && _ctx.authorizationCBs[category.categoryName].length)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
                      start: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(category.name)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode("div", _hoisted_3, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.authorizationCBs[category.categoryName], (authCBInfo, ind) => {
                        return (_openBlock(), _createBlock("div", {
                          key: ind,
                          class: "p-xl-3 p-lg-4 p-md-6 p-sm-12"
                        }, [
                          _createVNode("div", _hoisted_4, [
                            _createVNode(_component_InputSwitch, {
                              id: 'cb-' + index + '-' + ind,
                              modelValue: _ctx.role[authCBInfo.fieldName],
                              "onUpdate:modelValue": ($event: any) => (_ctx.role[authCBInfo.fieldName] = $event),
                              disabled: authCBInfo.enableForRole && _ctx.role.roleTypeCD === 'ADMIN',
                              onChange: ($event: any) => (_ctx.authChanged(authCBInfo.fieldName, _ctx.role[authCBInfo.fieldName]))
                            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "disabled", "onChange"]),
                            _createVNode("label", {
                              for: 'cb-' + index + '-' + ind
                            }, _toDisplayString(_ctx.$t(authCBInfo.label)), 9, ["for"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}